// Single source of truth for the Provider Hub semantic profile URLs. These are RELATIVE, router-basename
// paths (no origin / customUIBaseUrl prefix) suitable for history.push within the SPA. The link hooks
// (useProviderLink/useContractEntityLink/useOrganizationLink) wrap these with window.customUIBaseUrl to
// produce absolute hrefs for new-tab / anchor links; ProviderHubContext uses them directly for history.push.
//
// The route patterns matching these are declared in CountyProjectOverview.tsx and their params are
// hydrated in ProviderHubContext. Keep the three in sync.

const providerHubBasePath = (projectId: number | string): string => `/projects/${projectId}/provider-hub`;

// NOTE: servicingProviderKey is intentionally NOT encoded — it can legitimately contain characters like ':'
// (e.g. "npi:1") that are path-safe, and the pre-existing provider link + deep-link route were built this way.
// Hydration decodeURIComponent()s the param, which is a harmless no-op on these unencoded keys.
export const providerProfilePath = (projectId: number | string, runConfigurationId: number, servicingProviderKey: string): string =>
  `${providerHubBasePath(projectId)}/run/${runConfigurationId}/provider-profile/${servicingProviderKey}`;

export const contractEntityProfilePath = (projectId: number | string, runConfigurationId: number, contractEntityId: number): string =>
  `${providerHubBasePath(projectId)}/run/${runConfigurationId}/contract-entity-profile/${contractEntityId}`;

export const organizationProfilePath = (projectId: number | string, runConfigurationId: number, organizationNpi: string, contractEntityId: number): string =>
  `${providerHubBasePath(projectId)}/run/${runConfigurationId}/organization-profile/${encodeURIComponent(organizationNpi)}/${contractEntityId}`;

export const hospitalProfilePath = (projectId: number | string, runConfigurationId: number, ccn: string): string =>
  `${providerHubBasePath(projectId)}/run/${runConfigurationId}/hospital-profile/${encodeURIComponent(ccn)}`;
